var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadsChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00047 7.21882L4.70062 10.5187L3.75781 9.57586L8.00047 5.33322L12.2431 9.57586L11.3003 10.5187L8.00047 7.21882Z",
    fill: "#0D0D12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsChevronDown);
export default __webpack_public_path__ + "static/media/LeadsChevronDown.42285a970b26e26e654567cfd5f1eb23.svg";
export { ForwardRef as ReactComponent };